<template>
    <div class="container-outline">
        <div class="register">
            <div class="title">Register</div>
            <div class="top-squence">
                <head-register :dataSquence="{ id: 1, title: 'profil pialang' }" />
            </div>
            <div class="content-register">
                <div class="container">
                    <ProfilPerusahaan :statementProfil="form.has_set_company_profile" @updateValue="checkStatement" @inputBroker="setBrokerName" />
                    <div class="button">
                        <div></div>
                        <!-- <router-link to="/simulasi"> -->
                        <button class="btn-primer" type="submit" @click="checkValidasiStatement">
                            <b-spinner small v-if="isLoading"></b-spinner>
                            <div v-else>Selanjutnya</div>
                        </button>
                        <!-- </router-link> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import ProfilPerusahaan from "../assets/filedownload/ProfilPerusahaan";
import HeadRegister from "./component/HeadRegister.vue";

export default {
    components: {
        ProfilPerusahaan,
        HeadRegister,
    },

    data() {
        return {
            today: "",
            formStatement: false,
            isLoading: false,
            idCustomer: "",
            form: {
                has_set_trading_simulation: "",
                has_confirm_costumer: "",
                has_investment_experience: "",
                has_set_company_profile: false,
                has_set_investment_experience: "",
                has_set_mandate: "",
                has_set_risk: "",
                has_set_trading_rules: "",
                step: "companyProfil",
                completeness_verification: "",
                disclosure_customer: "",
                disclosure_risk: "",
                disclosure_mandate: "",
                broker_agent: "Yudo Hutomo",
            },
        };
    },

    mounted() {
        var today = new Date();
        today.setFullYear(today.getFullYear());
        this.today = new Date().toISOString().split("T")[0];
        axios.get("/v2/kyc/customer").then((res) => {
            let customer = res.data.data.customer;
            this.idCustomer = customer._id;
            this.form.has_set_trading_simulation = customer.has_set_trading_simulation;
            this.form.has_confirm_costumer = customer.has_confirm_costumer;
            this.form.has_investment_experience = customer.has_investment_experience;
            this.form.has_set_company_profile = customer.has_set_company_profile;
            this.form.has_set_investment_experience = customer.has_set_investment_experience;
            this.form.has_set_mandate = customer.has_set_mandate;
            this.form.has_set_risk = customer.has_set_risk;
            this.form.has_set_trading_rules = customer.has_set_trading_rules;
            this.form.completeness_verification = customer.completeness_verification;
            this.form.disclosure_customer = customer.disclosure_customer;
            this.form.disclosure_risk = customer.disclosure_risk;
            this.form.disclosure_mandate = customer.disclosure_mandate;
        });
    },

    methods: {
        checkStatement(value) {
            this.form.has_set_company_profile = value;
        },
        setBrokerName(value) {
            this.form.broker_agent = value;
        },
        checkValidasiStatement() {
            this.isLoading = true;
            if (this.form.has_set_company_profile) {
                let methode;
                if (this.idCustomer) {
                    methode = {
                        url: "/v2/kyc/customer/" + this.idCustomer,
                        method: "PUT",
                        data: this.form,
                    };
                } else {
                    methode = {
                        url: "/v2/kyc/customer",
                        method: "POST",
                        data: this.form,
                    };
                }
                axios(methode)
                    .then((res) => {
                        let status = res.data.data.status_code;
                        if (status == "00") {
                            this.isLoading = false;
                            this.$router.push("/simulasi");
                        }
                    })
                    .catch((error) => {
                        this.isLoading = false;
                        console.log(error);
                        this.$toast.error("Cek kembali inputan anda");
                    });
            } else {
                this.isLoading = false;
                this.$toast.error("Pernyataan menerima belum disetujui");
            }
        },
    },
};
</script>

<style scoped>
.container-outline {
    width: 70%;
    /* background: #fff; */
}

.top-squence {
    width: 85%;
    border-radius: 10px 10px 0 0;
    margin: 0 auto;
    background: #000e22;
    padding: 29px 20px;
    font-size: 14px;
}

.top-squence ul {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 0;
}

.top-squence ul li {
    list-style: none;
    text-align: center;
    font-size: 10px;
    color: #40688e;
    position: relative;
    width: 91px;
}

.top-squence ul li div {
    background: transparent;
    border: solid 0.1px #40688e;
    color: #40688e;
    border-radius: 50%;
    width: 27px;
    font-size: 16px;
    font-weight: 600;
    margin: 2px auto;
}

.li-active {
    color: #c59733 !important;
}

.li-active::before {
    content: "";
    position: absolute;
    width: 85px;
    top: 32%;
    left: -60px;
    border: solid 1px #c59733;
}

.li-active:first-child::before {
    display: none;
}

.li-active:nth-child(3)::before {
    border: dashed 1px #c59733;
}

.top-squence ul li div.squnce-active {
    position: relative;
    background: #c59733;
    color: #000e22;
    border: solid 0.5px #c59733;
}

.top-squence ul li div.squnce-process {
    position: relative;
    border: solid 0.5px #c59733;
    color: #c59733;
}

.form-error {
    font-size: 12px;
    margin: 5px 210px;
    color: #e74c3c;
}

.afiliasi {
    width: 100%;
    background: #2222;
    color: #ff6f00;
    text-align: center;
    position: absolute;
    left: 0;
    top: 0;
    margin-top: 62px;
    padding: 10px;
    height: 60px;
    line-height: 2.5;
}

.afiliasi img {
    width: 30px;
    margin-right: 10px;
}

.kecamatan {
    width: 39% !important;
    margin-right: 20px;
}

.rt-rw {
    font-size: 13px;
    margin-right: 10px;
}

.rw {
    margin-left: 22px;
}

.input-rt-rw {
    width: 10% !important;
    text-align: center;
}

.form-ttl-bagi {
    width: 23%;
    text-transform: lowercase;
}

.deactive {
    display: none;
}

.clickCheck {
    width: 17px;
    height: 20px;
    position: absolute;
    top: -7px;
    left: -2px;
    z-index: 3;
    cursor: pointer;
}

.npwpActive {
    display: block;
    transition: all 0.5s ease-out;
    position: relative;
    top: -20px;
}

.npwp-no {
    font-size: 14px;
}

.content-modal {
    background: white;
    width: 50%;
    margin: 5% auto;
    padding: 20px;
    border-radius: 10px;
}

.title-modal {
    height: 50px;
    font-size: 20px;
    font-weight: bold;
}

.close {
    margin-top: -32px;
}

.footer-modal {
    margin: 50px 22px 10px;
}

.footer-modal div {
    width: 100%;
    text-align: center;
    margin: 0 auto;
}

.show-content {
    display: none;
}

.modalActive {
    display: block;
}

.konfirmasi {
    font-size: 13px;
    margin: 50px 0 10px 0;
    width: 96.5%;
}

.konfirmasiYa {
    color: #2ecc71;
}

.konfirmsaiTidak {
    color: #e74c3c;
}

.input-bappebti {
    width: 20%;
    display: flex;
    justify-content: flex-end;
}

.form-platform {
    display: flex;
}

.input-babepti[type="radio"]:checked,
.input-babepti[type="radio"]:not(:checked) {
    position: absolute;
    left: -999999px;
    cursor: pointer;
}

.input-babepti[type="radio"]:checked + label {
    color: #c59733;
}

.label-babepti {
    width: 40px;
    cursor: pointer;
    font-weight: bold;
}

.bappebti {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 14px;
}

.bappebti span {
    font-weight: bold;
    margin: 0 0 0 40px;
    cursor: pointer;
}

.bappebti span:hover {
    text-decoration: underline;
}

.label--checkbox {
    font-size: 13px;
    position: relative;
    margin-left: 20px;
}

.label-radio {
    width: 185px;
    cursor: pointer;
}

.outer {
    margin: 10px 25px 10px 15px;
}

.register {
    margin: 46px 0;
}

.pernyataan-bappebti {
    margin-bottom: 3rem;
}

.form-checkbox {
    display: flex;
}

label {
    font-size: 14px;
    width: 205px;
    display: inline-block;
}

.detail-alamat {
    width: 175px;
    margin: 0 0 0 30px;
}

.form-input,
select {
    width: 73%;
    height: 45px;
    border-radius: 7px;
    border: none;
    text-transform: capitalize;
    color: #707070;
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

select::first-letter,
select::first-line {
    text-transform: uppercase;
}

.form-input:focus,
select:focus {
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

.tempat {
    width: 41%;
    margin: 0 25px 0 0;
}

.tanggal {
    width: 29%;
    background: transparent;
    border: none;
    padding-right: 10px;
    text-transform: lowercase;
}

.birtday {
    background: transparent;
    border: none;
    padding-right: 3px;
    width: 100%;
    text-transform: lowercase;
}

.birtday::-webkit-calendar-picker-indicator {
    opacity: 0;
    cursor: pointer;
}

.tanggal::-webkit-calendar-picker-indicator {
    opacity: 0;
    cursor: pointer;
}

.input-button {
    height: 50px;
    position: relative;
    display: inline-flex;
    align-items: center;
    border: none;
    background: #f8f9fe;
    border-radius: 10px;
    top: 0px;
    width: 29%;
}

.input-button::after {
    content: "";
    position: absolute;
    width: 49px;
    height: 48px;
    background: url("../assets/calendar.svg") no-repeat center #000e22;
    background-size: 22px;
    right: 0;
    border-top-right-radius: 9px;
    border-bottom-right-radius: 9px;
    border-left: inherit;
    cursor: pointer;
}

.pos-telepon {
    width: 25%;
}

.identitas {
    width: 20%;
    margin: 0 27px 0 0;
    background-position-x: 92%;
}

.no-identitas {
    width: 50%;
}

.form-ktp-bagi {
    width: 24%;
    margin-right: 30px;
}

.icon-calender {
    font-size: 20px;
    color: white;
}

.content-register {
    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
    background: #ffffff;
    border-radius: 5px;
}

.title {
    font-size: 25px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    margin: 0 0 50px;
}

.navigation {
    margin: 0 0 50px;
    font-size: 10px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
}
.container {
    width: 90%;
    padding-top: 45px;
}

.nav-root {
    display: flex;
    justify-content: space-between;
    margin: 0 0 50px;
    position: relative;
    /* background-color: lightcyan; */
}

.list-root {
    list-style: none;
    width: 40%;
    padding: 15px;
    text-align: center;
    color: rgba(112, 112, 112, 0.5);
}

.active {
    border-top-right-radius: 15px;
    background-color: #c59733;
    color: white;
    position: relative;
    text-align: center;
    position: absolute;
    width: 20%;
    top: -54px;
}

.active:first-child {
    border-top-left-radius: 15px;
}

.active:last-child {
    border-top-right-radius: 15px;
    border-bottom-right-radius: 0;
}

input:disabled,
select:disabled {
    cursor: not-allowed;
}

.active::before {
    z-index: -1;
    position: absolute;
    content: "";
    display: inline-block;
    width: 50px;
    height: 65px;
    background-color: #1f354a;
    top: -2px;
    left: -41px;
    border: 2px solid #000e22;
}

.active:first-child::before {
    opacity: 0;
}

.button {
    display: flex;
    justify-content: space-between;
    padding: 76px 15px;
}

.sub-title {
    margin: 0 0 73px;
    font-size: 18px;
    font-weight: bold;
}

.arrow {
    margin-left: 10px;
    margin-right: 10px;
    border: solid #1f354a;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 4px;
    transform: rotate(45deg);
    vertical-align: super;
}

.wrap-arrow {
    position: absolute;
    display: inline-block;
    width: 56px;
    height: 48px;
    /* border: solid 1px; */
    right: 50px;
    top: 1px;
    border-radius: 10px;
    text-align: center;
    padding: 15px 9px;
    background: white;
}

.konfirmasi-ktp {
    width: 54%;
    position: relative;
    margin-left: auto;
}

.tanggal-aktif {
    width: 22%;
    text-transform: lowercase;
}

.identityActive {
    width: 20%;
    margin-right: 2%;
    /* display: none; */
}

.masa-aktif {
    font-size: 13px;
    margin-right: 10px;
}

.activeForm {
    display: inline-block;
}

@media (min-width: 768px) and (max-width: 1190px) {
    .list-root {
        font-size: 13px;
    }
    .active {
        padding: 10px;
        text-align: center;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .active::before {
        width: 28px;
        left: -25px;
    }

    label,
    select,
    .form-input,
    .detail-alamat {
        width: 100%;
    }

    .tempat {
        width: 55%;
    }
    .tanggal {
        width: 31%;
    }
    .identitas {
        width: 35%;
    }

    .no-identitas {
        width: 60%;
    }

    .provincy,
    .city,
    .kecamatan {
        margin-left: 30px;
        width: 94.5%;
    }

    .kode-pos {
        margin-left: 30px;
        width: 25%;
    }

    .input-button {
        right: 0;
        width: 40%;
        top: 30px;
    }
}

@media (max-width: 768px) {
    .container-outline {
        width: 90%;
    }

    li > span {
        display: none;
    }

    .form-input,
    select,
    .input-button {
        width: 100%;
    }

    .birtday,
    .kecamatan,
    .input-rt-rw {
        width: 100% !important;
        text-align: left;
    }

    .register {
        margin: 20px 0;
    }

    .title {
        font-size: 18px;
        margin: 0 0 20px;
    }

    .sub-title {
        margin-bottom: 20px;
    }

    .top-squence {
        width: 100%;
        padding: 15px 10px;
    }

    .container {
        width: 100%;
        padding: 25px 20px;
    }

    .identitas,
    .form-ktp-bagi,
    .tanggal-aktif,
    .tempat,
    .kecamatan,
    .input-rt-rw {
        margin: 0 0 10px;
    }

    .detail-alamat,
    .rt-rw {
        margin: 0 0 0.5rem;
    }

    .form-checkbox {
        align-items: flex-start;
    }

    .label--checkbox {
        margin-left: 10px;
    }

    .button {
        display: block;
        width: 100%;
        padding: 25px 20px;
        text-align: center;
    }

    .btn-scondary,
    .btn-primer {
        width: 100%;
    }

    .btn-scondary {
        margin-bottom: 20px;
    }

    .content-modal {
        width: 95%;
    }

    .wrap-document {
        width: 100%;
        padding: 30px 0;
    }

    .form-error {
        margin-left: 0;
    }
}
</style>
